import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radio", "typeFields"]

  connect() {
    // Show initial fields based on selected value if any
    const selectedType = this.element.dataset.userTypeSelectionSelectedValue
    if (selectedType) {
      this.showFieldsForType(selectedType)
    }
  }

  select(event) {
    const clickedCard = event.currentTarget
    const userType = clickedCard.dataset.userType
    
    // Find the radio button for this user type
    const radioButton = clickedCard.querySelector('input[type="radio"]')
    if (radioButton) {
      radioButton.checked = true
      
      // Update visual state of all cards
      this.updateCardStates(userType)
    }
  }

  radioChanged(event) {
    const selectedType = event.target.value
    this.updateCardStates(selectedType)
  }

  updateCardStates(selectedType) {
    // Find all cards in this component
    const cards = this.element.querySelectorAll('[data-user-type]')
    
    cards.forEach(card => {
      const cardType = card.dataset.userType
      const isSelected = cardType === selectedType
      
      // Update card classes based on selection state
      this.updateCardClasses(card, isSelected)
    })
  }

  updateCardClasses(card, isSelected) {
    // Remove existing selection classes
    card.classList.remove(
      'border-primary', 'bg-primary/5', 'ring-2', 'ring-primary',
      'border-gray-300', 'bg-white',
      'border-green-500', 'bg-green-50', 'ring-green-500',
      'border-green-300'
    )
    
    // Determine card category from existing classes
    const isRestricted = card.classList.contains('border-green-300') || 
                        card.classList.contains('border-green-500') ||
                        card.querySelector('.bg-green-100')
    
    // Apply appropriate classes based on selection and category
    if (isRestricted) {
      if (isSelected) {
        card.classList.add('border-green-500', 'bg-green-50', 'ring-2', 'ring-green-500')
      } else {
        card.classList.add('border-green-300', 'bg-green-50')
      }
    } else {
      // Public user type
      if (isSelected) {
        card.classList.add('border-primary', 'bg-primary/10', 'ring-2', 'ring-primary')
      } else {
        card.classList.add('border-gray-300', 'bg-white')
      }
    }
  }

  handleTypeChange(event) {
    const selectedType = event.target.value
    this.showFieldsForType(selectedType)
    // Don't update card states for bulk invite form
  }

  showFieldsForType(type) {
    if (!this.hasTypeFieldsTarget) return
    
    // Hide all type-specific fields
    const allFields = this.typeFieldsTarget.querySelectorAll('[data-user-type]')
    allFields.forEach(field => {
      field.style.display = 'none'
    })
    
    // Show fields for selected type
    if (type) {
      const typeField = this.typeFieldsTarget.querySelector(`[data-user-type="${type}"]`)
      if (typeField) {
        typeField.style.display = 'block'
      }
    }
  }
}